Postlogin.Lesson = (function (my) {
    my.TrueFalse = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container;
        const numberOfOptions = Object.keys(me.options).length;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }

            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfOptions);

            // add the question to the page
            if (me.activity_data.question_text) {
                const question = $('<div class="question"></div>');
                if (me.activity_data.question_audio) {
                    question.attr('data-audio', me.activity_data.question_audio);
                }
                question.append($(`<h2 class="question-title">${me.activity_data.question_text}</h2>`));

                question.on('click', () => {
                    me.speakQuestion();
                });

                segmentContainer.append(question);
            }

            // add the options
            const optionsContainer = $('<div></div>').addClass('options-container');

            $.each(me.options, (optionId, option) => {
                const optionItem = $('<div></div>').addClass(`item option-${optionId}`);

                if (option.answer_image) {
                    optionItem.addClass('has-image');
                    optionItem.append(`<img src="${option.answer_image}" />`);
                    if (option.answer) {
                        optionItem.append(`<div class="option-text cartoony"><span>${option.answer}</span></div>`);
                    }
                } else {
                    optionItem.addClass('text-only');
                    if (option.answer) {
                        optionItem.append(`<div class="option-text cartoony"><span>${option.answer}</span></div>`);
                    }
                }

                optionItem.on('click', function () {
                    Postlogin.Lesson.stopAllSounds();

                    const feedbackTitle = me.options[optionId].feedback_title; // $.trim($('#option-feedback-'+option_id).attr('data-title'));
                    const feedbackAudio = me.options[optionId].feedback_audio; // $.trim($('#option-feedback-'+option_id).attr('data-audio'));
                    const feedbackBody = me.getOptionFeedback(optionId);

                    let cssClass;
                    if (option.correct) {
                        cssClass = 'correct';
                        // should we play this sound? It sorta conflicts with the spoken feedback text...
                        Postlogin.Lesson.playSoundEffect('correct');
                    } else {
                        cssClass = 'incorrect';
                        Postlogin.Lesson.playSoundEffect('incorrect');
                    }

                    me.setCompleted();

                    $(this).addClass(`used ${cssClass}`);

                    if (feedbackBody) {
                        // show the option-feedback modal window
                        Postlogin.Lesson.Popup.showModal({
                            title: feedbackTitle,
                            body: feedbackBody,
                            class: cssClass,
                            overlay: 'light',
                            smaller: true,
                            actions: [
                                {
                                    label: 'Continue',
                                    cssClass: 'btn-xl btn-success btn-continue',
                                    onClick(e) {
                                        e.stopPropagation();
                                        Postlogin.Lesson.Popup.hideModal();
                                    },
                                },
                                {
                                    label: 'Replay <i class="fa fa-volume-up"></i>',
                                    cssClass: 'btn-replay-audio btn-default pull-left',
                                    onClick(e) {
                                        e.stopPropagation();
                                        $(this).fadeOut();
                                        Postlogin.Lesson.playSound(feedbackAudio, 0, null, () => {
                                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                                        });
                                    },
                                },
                            ],
                            onShow() {
                                $('#beep-9-modal .btn-replay-audio').hide();
                                if (feedbackAudio) {
                                    if (
                                        Postlogin.Lesson.soundEnabled()
                                        && !$(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).hasClass(
                                            `dont-disable-feedback-${optionId}continue`,
                                        )
                                    ) {
                                        $('#beep-9-modal .btn-continue').prop('disabled', true);
                                    }
                                    Postlogin.Lesson.playSound(feedbackAudio, 500, null, () => {
                                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                                        $('#beep-9-modal .btn-continue').prop('disabled', false);
                                        $(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).addClass(
                                            `dont-disable-feedback-${optionId}continue`,
                                        );
                                    });
                                }
                            },
                            onHide() {
                                Postlogin.Lesson.pauseCurrentSound();
                                if (!me.help_enabled) {
                                    $('#beep-9-modal').removeClass('enabled');
                                }
                                me.advance();
                            },
                        });
                    }
                });

                // randomize order of items (if shuffled == 1)
                if (+me.activity_data.shuffled === 1 && Math.floor(Math.random() * 2)) {
                    optionsContainer.prepend(optionItem);
                } else {
                    optionsContainer.append(optionItem);
                }
            });

            segmentContainer.append(optionsContainer);
            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.replay = function (forceShowHelp = false) {
            Postlogin.Lesson.hideNextButton();

            $(container)
                .find('.item')
                .each(function () {
                    $(this).removeClass('used correct incorrect');
                });

            Postlogin.Lesson.hideNextButton();

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    me.speakQuestion(500, () => {
                        if (me.completed && !me.last) {
                            Postlogin.Lesson.showNextButton();
                        }
                    });
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
